module.exports = __webpack_public_path__ + "static/flags/GH-194c5a75f48e14da2e6fe94999a72107.gif";